import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import { trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';

const requestRACELigibility = () => ({ type: types.REQUEST_RAC_ELIGIBILITY });

const receiveRACELigibilityError = () => ({ type: types.RECEIVE_RAC_ELIGIBILITY_ERROR });

const receiveRACELigibility = (payload) => ({ type: types.RECEIVE_RAC_ELIGIBILITY, payload });

const requestRACSubmit = (payload) => ({ type: types.REQUEST_RAC_SUBMIT, payload });

const receiveRACSubmitFail = (payload) => ({ type: types.REQUEST_RAC_SUBMIT_FAIL, payload });

const receiveRACSubmitError = () => ({ type: types.RECEIVE_RAC_SUBMIT_ERROR });

const receiveRACSubmit = (payload) => ({ type: types.RECEIVE_RAC_SUBMIT, payload });

const makeRACInEligibility = () => ({ type: types.MAKE_RAC_INELIGIBLE });

// -- LOCAL ACTIONS --
export const showPopUp = () => ({ type: types.RAC_SHOWPOPUP });

export const hidePopUp = () => ({ type: types.RAC_HIDEPOPUP });

export const getNewNum = () => ({ type: types.RAC_GET_NEWNUM });

export const getPrimaryNum = () => ({ type: types.RAC_GET_PRIMARY });

export const getRACEligibility = () => (dispatch, getState) => {
  dispatch(requestRACELigibility());
  // if IDI enabled get segment from IDI state else nothing
  const state = getState();
  const idiContactChannels = state.contactChannels.OriginalRiskResponse;
  let segName = null;

  if (Array.isArray(idiContactChannels) && idiContactChannels.length) {
    const racContactOption = idiContactChannels.find((contactChannel) => contactChannel.name === 'RAC');

    if (typeof racContactOption === 'object'
      && Object.prototype.hasOwnProperty.call(racContactOption, 'additional_data')
      && Array.isArray(racContactOption.additional_data)) {
      const queueData = racContactOption.additional_data.find((data) => data.key === 'queue_id');

      if (typeof queueData === 'object') {
        segName = queueData.value;
      }
    }
  }

  const segNameLoLi = _get(getState(), 'smcResultKeeper.topicTreeSelectResult.topicRefId');

  if (Page.isIDIenableForRAC() && !(segName || segNameLoLi)) {
    return dispatch(makeRACInEligibility());
  }
  // if IDI is true & segment is available
  const idiEnable = (Page.isIDIenableForRAC() && !!segName) ? `?segment=${segName || segNameLoLi}` : '';
  const racURL = `/smarthelp/rac-eligibility${idiEnable}`;
  return axios.get(racURL)
    .then((response) => {
      const racInfo = ((response || {}).data || {}).racInfo;
      dispatch(receiveRACELigibility(racInfo));
    })
    .catch(() => {
      dispatch(receiveRACELigibilityError());
    });
};

export function deformatPhoneNumber(s) {
  return (`${s}`).replace(/\D/g, '');
}

export const doRACSubmit = (code, phoneNumber, segmentName) => (dispatch) => {
  dispatch(requestRACSubmit({ code, num: deformatPhoneNumber(phoneNumber) }));
  const racSubmitURL = '/smarthelp/rac-submit';

  return axios.post(racSubmitURL, { phoneNumber: deformatPhoneNumber(phoneNumber), segment_name: segmentName, _csrf: document.body.getAttribute('data-token') })
    .then((response) => {
      const racData = ((response || {}).data || {}).racInfo;
      if (racData.success) {
        // Success case
        dispatch(receiveRACSubmit(racData));
      } else {
        // Failure case
        trackPage({ id: 'requestACallError', link: 'racFailureAlert' });
        dispatch(receiveRACSubmitFail(racData));
      }
    })
    .catch(() => {
      dispatch(receiveRACSubmitError());
    });
};
